import {ModuleWithProviders} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuthorizedRouteFactory as Factory} from '@application/helper/routing/authorized-route-factory';
import {NavigationId} from '@application/helper/routing/navigation-id.enum';
import {PlanningComponent} from './planning.component';

export const planningRoutes = [Factory.createPrototypeComponentRoute(PlanningComponent, {route: '', requiredPermission: null, id: NavigationId.PLANNING, parentId: NavigationId.PLANNING_MODULE})];

export const planningRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(planningRoutes);
